import React from "react";
import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { site } from "../../data/site";

const MobileBottomBar = () => {
  return (
    <div
      className="xl:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 bg-white border-t border-neutral-200 shadow-[0_-4px_16px_rgba(0,0,0,0.06)]"
      data-testid="mobile-bottom-bar"
    >
      <a
        href={site.phoneHref}
        data-testid="bottombar-call"
        className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold text-[#1A3D84]"
      >
        <Phone size={17} /> Call Now
      </a>
      <Link
        to="/contact"
        data-testid="bottombar-estimate"
        className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold text-white bg-[#CD1422]"
      >
        <FileText size={17} /> Free Estimate
      </Link>
    </div>
  );
};

export default MobileBottomBar;
